import React, { Component } from "react";
import { Col } from "reactstrap";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import FetchServerData from "../../../provider/FetchServerData";
import PtsAlert from "../../ptsAlert/PtsAlert";
import { withRouter } from "../../../withRouter";
import { ValidatorForm } from "react-material-ui-form-validator";
import { Autocomplete } from "@mui/material";
import TextField from "@material-ui/core/TextField";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import PrintIcon from "@material-ui/icons/Print";
import ReactToPrint from "react-to-print";
import Button from "@material-ui/core/Button";
import store from "../../../redux/store";
import Utils from "../../../provider/Utils";
import PtsButton from "../../buttons/PtsButton";
import AssetStaticDataAction from "../../../redux/assetStaticData/AssetStaticDataAction";
import DeleteIconButton from "../../buttons/DeleteIconButton";
import EditIconButton from "../../buttons/EditIconButton";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import CancelIconButton from "../../buttons/CancelIconButton";
import SaveButton from "../../buttons/SaveButton";

class AssetCodeMasterList extends Component {
  header = store.getState().header.header;
  customerList = store.getState().assetStaticData.assetCodeData?.customerList;
  materialTypeList =
    store.getState().assetStaticData.assetCodeData?.materialTypeList;
  assetCodeRefList = [];
  constructor() {
    super();
    this.state = {
      assetCodeId: "",
      custabbreviation: null,
      customerName: null,
      customer: null,
      materialtype: null,
      pocketcode: "",
      description: "",
      initialPage: 0,
      pageSize: 10,
      assetCodeList: [],
      customerList: [],
      materialTypeList: [],
      // column: "asc",
      // direction: "desc",
      column: null,
      direction: "desc",
      render: false,
      addRow: false,
      getCreatePermission: false,
      getUpdatePermission: false,
      getDeletePermission: false,
      isAscending: false,
    };
    this.getAssetCodeList();
  }

  componentDidMount() {
    const postObject = {
      header: this.header,
    };
    FetchServerData.callPostService(
      "/accountCodeStaticms/get",
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        let staticData = output.data;
        let assetStaticData = {
          materialTypeList: staticData.materialTypeList,
          customerList: staticData.customerList,
        };
        store.dispatch(
          AssetStaticDataAction.setAssetStaticData(assetStaticData)
        );
      } 
    });
  }

  getAssetCodeList() {
    const postObject = {
      header: this.header,
    };
    FetchServerData.callPostService("/assetcodems/getList", postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          let getPermission = Utils.getRolePermission(
            output.data.privilegeList
          );
          let getCreatePermission = getPermission[1];
          let getUpdatePermission = getPermission[3];
          let getDeletePermission = getPermission[4];
          let assetCodeList = output.data.assetCodes;
          let isPaging = false;
          if (assetCodeList.length > this.state.pageSize) {
            isPaging = true;
          }
          // for (let i = 0; i < assetCodeList.length; i++) {
          //   assetCodeList[i].custAbbreviation = {
          //     abbreviation: assetCodeList[i].custabbreviation,
          //   };
          // }
          this.setState({
            render: true,
            addRow: true,
            assetCodeList: assetCodeList,
            isPaging: isPaging,
            initialPage: this.state.initialPage,
            getCreatePermission: getCreatePermission,
            getUpdatePermission: getUpdatePermission,
            getDeletePermission: getDeletePermission,
          });
        } 
      }
    );
  }

  createAssetCodeToBackend() {
    if (this.state.pocketcode?.length !== 4) {
      PtsAlert.error("Pocket code must be 4 Character log");
      return false;
    }
    console.log(this.state.customer);
    const postObject = {
      header: this.header,
      assetCode: {
        customerId: this.state.customer?.id,
        custabbreviation: this.state.customer?.abbreviation,
        pocketcode: this.state.pocketcode,
        description: this.state.description,
        materialtype: {
          id: this.state.materialtype?.id,
        },
      },
    };
    FetchServerData.callPostService("/assetcodems/create", postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          let assetCodeInfo = output.data.assetCode;
          this.setState({
            render: true,
            assetCodeOpen: false,
            action: "view",
            assetCodeList: [assetCodeInfo, ...this.state.assetCodeList],
          });
        } 
      }
    );
    // }
    // }
  }
  updateAssetCodeToBackend() {
    if (this.state.pocketcode.length !== 4) {
      PtsAlert.error("Pocket code must be 4 Character log");
      return false;
    }

    const postObject = {
      header: this.header,
      assetCode: {
        customerId: this.state.customer?.id,
        custabbreviation: this.state.customer?.abbreviation,
        pocketcode: this.state.pocketcode,
        description: this.state.description,
        materialtype: { id: this.state.materialtype?.id },
        id: this.state.assetCodeId,
      },
    };
    FetchServerData.callPostService("/assetcodems/update", postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          this.getAssetCodeList();
          this.setState({
            render: true,
            assetCodeOpen: false,
          });
        } 
      }
    );
  }
  deleteAssetCodeToBackend = (assetCodeId) => {
    console.log(assetCodeId);
    const postObject = {
      header: this.header,
      assetCode: {
        id: assetCodeId,
      },
    };
    FetchServerData.callPostService("/assetcodems/delete", postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          // var newList = output.data.assetCode;
          for (let i = 0; i < this.state.assetCodeList.length; i++) {
            if (this.state.assetCodeList[i].id === assetCodeId) {
              this.state.assetCodeList.splice(i, 1);
            }
          }
          this.setState({
            assetCodeList: this.state.assetCodeList,
            render: true,
          });
          PtsAlert.success(output.message);
        } 
      }
    );
  };

  handleCusAbbreviationChange(selectedValue) {
    this.setState({
      custabbreviation: selectedValue,
    });
  }

  addAssetCode() {
    let assetInfos = this.state.assetCodeList;
    let assetInfo = {
      action: "create",
      operation: "add",
      customerName: null,
      customer: null,
      custabbreviation: null,
      materialtype: null,
      pocketcode: "",
      description: "",
      assetCodeId: "",
    };
    assetInfos.push(assetInfo);
    this.setState({
      assetCodeList: assetInfos,
      addRow: true,
      action: "create",
    });
  }

  onAssetCodeRemove(item) {
    let items = [];
    if (item.operation && "add" === item.operation) {
      /* Added Item Deleted, Remove from list */
      let index = item.srno;
      for (let i = 0; i < this.state.assetCodeList.length; i++) {
        if (this.state.assetCodeList[i].operation === "add" && index === i) {
          this.assetCodeRefList.splice(i, 1);
        } else {
          items.push(this.state.assetCodeList[i]);
        }
      }
      this.setState({ assetCodeList: items, addRow: false });
    }
  }

  onAssetCodeEditClick(e) {
    console.log(e);
  }

  onSort(column) {
    const direction = this.state.column
      ? this.state.direction === "desc"
        ? "asc"
        : "desc"
      : "desc";
    const sortedData = this.state.assetCodeList.sort((a, b) => {
      if (column === "description") {
        if (a.description === null) {
          return 1;
        }
        if (b.description === null) {
          return -1;
        }
        const nameA = a.description?.toLowerCase(); // ignore upper and lowercase
        const nameB = b.description?.toLowerCase(); // ignore upper and lowercase

        if (nameA === nameB) {
          return 0;
        }
        if (direction === "asc") {
          return nameA < nameB ? -1 : 1;
        }
        return nameA > nameB ? 1 : -1;
      } else if (column === "custabbreviation") {
        if (a.code === null) {
          return 1;
        }
        if (b.code === null) {
          return -1;
        }
        const nameA = a.code?.toLowerCase(); // ignore upper and lowercase
        const nameB = b.code?.toLowerCase(); // ignore upper and lowercase

        if (nameA === nameB) {
          return 0;
        }
        if (direction === "asc") {
          return nameA < nameB ? -1 : 1;
        }
        return nameA > nameB ? 1 : -1;
      } else {
        if (a.custabbreviation === null) {
          return 1;
        }
        if (b.custabbreviation === null) {
          return -1;
        }
        const nameA = a.custabbreviation?.toLowerCase(); // ignore upper and lowercase
        const nameB = b.custabbreviation?.toLowerCase(); // ignore upper and lowercase

        if (nameA === nameB) {
          return 0;
        }
        if (direction === "asc") {
          return nameA < nameB ? -1 : 1;
        }
        return nameA > nameB ? 1 : -1;
      }
    });

    if (direction === "desc") {
      sortedData.reverse();
    }

    this.setState({
      assetCodeList: sortedData,
      isAscending: !this.state.isAscending,
      column: column,
      direction: direction,
    });
  }

  setArrow = (column) => {
    let className = "sort-direction";

    if (this.state.column === column) {
      className += this.state.direction === "asc" ? " asc" : " desc";
    }
    return className;
  };

  getHeader() {
    const { column, direction } = this.state;
    return (
      <thead className="paginationTableThead">
        <tr>
          <th style={{ width: "5%" }} scope="col fw-bold ">
            #
          </th>
          <th style={{ width: "15%" }} scope="col fw-bold">
            Customer
          </th>
          <th
            style={{ width: "15%" }}
            scope="col fw-bold"
            sorted={column === "custabbreviation" ? direction : null}
            onClick={(e) => this.onSort("custabbreviation")}
          >
            Abbreviation
            {direction === "asc" ? (
              <>
                <ArrowUpwardIcon className="bonus-icon fs-5" />
              </>
            ) : (
              <>
                <ArrowDownwardIcon className="bonus-icon fs-5" />
              </>
            )}
          </th>
          <th style={{ width: "15%" }} scope="col fw-bold">
            Material Type
          </th>
          <th
            style={{ width: "15%" }}
            scope="col fw-bold"
            sorted={column === "code" ? direction : null}
            onClick={(e) => this.onSort("code")}
          >
            Pocket Code
            {direction === "asc" ? (
              <>
                <ArrowUpwardIcon className="bonus-icon  fs-5" />
              </>
            ) : (
              <>
                <ArrowDownwardIcon className="bonus-icon fs-5" />
              </>
            )}
          </th>
          <th
            style={{ width: "20%" }}
            scope="col fw-bold"
            onClick={(e) => this.onSort("description")}
            sorted={column === "description" ? direction : null}
          >
            Description
            {direction === "asc" ? (
              <>
                <ArrowUpwardIcon className="bonus-icon  fs-5" />
              </>
            ) : (
              <>
                <ArrowDownwardIcon className="bonus-icon  fs-5" />
              </>
            )}
          </th>
          <th style={{ width: "15%", textAlign: "center" }} scope="col fw-bold">
            Action
          </th>
        </tr>
      </thead>
    );
  }

  handleAssetCodeOpen() {
    this.setState({
      assetCodeOpen: true,
      action: "create",
      customerName: null,
      customer: null,
      custabbreviation: null,
      materialtype: null,
      pocketcode: "",
      description: "",
      assetCodeId: "",
    });
  }

  handleEditAssetOpen(id) {
    const rowData = this.state.assetCodeList.find((item) => item.id === id);
    this.setState({
      assetCodeOpen: true,
      action: "edit",
      assetCodeId: rowData.id,
      customerName: rowData.customerName,
      customer: {
        name: rowData.customerName,
        id: rowData.customerId,
        abbreviation: rowData.custabbreviation,
      },
      custabbreviation: rowData.abbreviation,
      materialtype: rowData.materialtype,
      pocketcode: rowData.pocketcode,
      description: rowData.description,
    });
  }

  handleAssetCodeClose() {
    this.setState({
      assetCodeOpen: false,
    });
  }

  handleCustomerChange(selectedValue) {
    this.setState({ customer: selectedValue });
  }

  handleMaterialTyepeChange(selectedValue) {
    this.setState({ materialtype: selectedValue });
  }

  handlePocketCodeChange(e) {
    let res = e.target.value;
    if (res.length <= 4) {
      this.setState({ pocketcode: res });
    }
  }

  handleDescriptionChange(e) {
    this.setState({
      description: e.target.value,
    });
  }

  render() {
    console.log(this.state.assetCodeList);
    this.printComponentRef = React.createRef();
    if (this.state.render === false) {
      return <div />;
    }

    return (
      <>
        <div style={{ maxWidth: "100%" }}>
          <div style={{ maxWidth: "100%" }}>
            <div className="row">
              <Col md={12} style={{ flexDirection: "column", display: "flex" }}>
                <div className="card">
                  <div className="row justify-content-between p-3">
                    <div className="d-flex col-12 col-lg-4 col-xl-4">
                      <div className="col-12 text-start totalResults">
                        {/* <span>Total Results:</span> */}
                      </div>
                    </div>
                    <div className="d-flex col-12 col-lg-8 col-xl-8">
                      <div className="col-12 text-end">
                        {/* <input
                        type="search"
                        id="gsearch"
                        placeholder="Search"
                        name="gsearch"
                        style={{ marginTop: "2px" }}
                      // value={this.state.searchText}
                      // onChange={this.onSearchChange.bind(this)}
                      />
                      <button
                        className="gsearchButton"
                      // onClick={this.onSearchClick.bind(this)}
                      >
                        <i className="fa fa-search" aria-hidden="true"></i>
                      </button> */}{" "}
                        &nbsp;&nbsp;
                        {/* {this.state.addRow ? */}
                        <ReactToPrint
                          trigger={() => (
                            <Button
                              variant="contained"
                              size="small"
                              style={{
                                background: "#0B6F9D",
                                color: "#fff",
                                marginRight: "1rem",
                                padding: "0.4rem  1.25rem",
                              }}
                              startIcon={<PrintIcon />}
                              // onClick={(e) => this.printContent(e)}
                            >
                              Print
                            </Button>
                          )}
                          content={() => this.printComponentRef}
                        />
                        <PtsButton
                          btnName="Add Asset Code"
                          type="submit"
                          onClick={this.handleAssetCodeOpen.bind(this)}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="table-responsive paginationTable">
                    <table
                      className="table text-start table-hover"
                      ref={(el) => (this.printComponentRef = el)}
                    >
                      {this.getHeader()}
                      <tbody>
                        {" "}
                        {this.state.assetCodeList?.map((rowData, index) => (
                          <tr className="hoverTable" key={index}>
                            <td style={{ width: "5%" }}>{index + 1}</td>
                            <td style={{ width: "15%" }}>
                              {rowData.customerName}
                            </td>
                            <td style={{ width: "15%" }}>
                              {rowData.custabbreviation}
                            </td>
                            <td style={{ width: "15%" }}>
                              {rowData.materialtype?.type}
                            </td>
                            <td style={{ width: "15%" }}>
                              {rowData.pocketcode}
                            </td>
                            <td style={{ width: "20%" }}>
                              {rowData.description}
                            </td>
                            <td style={{ width: "15%" }} key={rowData.id}>
                              <DeleteIconButton
                                onClick={() =>
                                  this.deleteAssetCodeToBackend(rowData.id)
                                }
                                title="Asset Code"
                                domainObject={rowData.code}
                              />
                              <EditIconButton
                                onClick={() =>
                                  this.handleEditAssetOpen(rowData.id)
                                }
                              />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  {this.state.totalRecords === 0 && (
                    <div className="row text-center p-2">
                      <h5>Data not Available</h5>
                    </div>
                  )}
                </div>
              </Col>
            </div>
          </div>
        </div>
        <Dialog
          open={this.state.assetCodeOpen}
          onClose={this.handleAssetCodeClose.bind(this)}
          maxWidth="xl"
          className="assetCodeDialogue"
        >
          <DialogTitle id="scroll-dialog-title">
            <span style={{ color: "#fff" }}>
              {this.state.action === "create"
                ? `Create Asset Code`
                : `Edit Asset Code`}
            </span>
          </DialogTitle>
          <IconButton
            aria-label="close"
            onClick={this.handleAssetCodeClose.bind(this)}
            style={{
              position: "absolute",
              right: 8,
              top: 4,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon style={{ color: "#fff", fontWeight: "600" }} />
          </IconButton>
          <ValidatorForm
            className="text-start"
            ref="form"
            onSubmit={
              this.state.action === "create"
                ? this.createAssetCodeToBackend.bind(this)
                : this.updateAssetCodeToBackend.bind(this)
            }
          >
            <DialogContent className="pb-2">
              <div className="row ps-4 pe-4">
                <div className="col-sm-12">
                  <div className="row p-1">
                    <div className="col-md-12" id="assetFormLabel">
                      <label
                        className="form-label "
                        htmlFor="collapsible-firstname"
                      >
                        Customer
                      </label>
                      <Autocomplete
                        id="customer"
                        fullWidth
                        disableClearable
                        options={this.customerList}
                        value={this.state.customer}
                        defaultValue={this.state.customer}
                        getOptionLabel={(option) => option.name}
                        onChange={(event, value) => {
                          this.handleCustomerChange(value);
                        }}
                        inputprops={{
                          style: { textTransform: "capitalize" },
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Please Select"
                            variant="outlined"
                            required
                          />
                        )}
                      />
                    </div>
                  </div>
                  <div className="row p-1">
                    <div className="col-md-12" id="assetFormLabel">
                      <label
                        className="form-label "
                        htmlFor="collapsible-lastname"
                      >
                        Material Type
                      </label>
                      <Autocomplete
                        id="customer"
                        fullWidth
                        disableClearable
                        options={this.materialTypeList}
                        value={this.state.materialtype}
                        defaultValue={this.state.materialtype}
                        getOptionLabel={(option) => option.type}
                        onChange={(event, value) => {
                          this.handleMaterialTyepeChange(value);
                        }}
                        inputprops={{
                          style: { textTransform: "capitalize" },
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Please Select"
                            variant="outlined"
                            required
                          />
                        )}
                      />
                    </div>
                  </div>
                  <div className="row p-1">
                    <div className="col-md-12" id="assetFormLabel">
                      <label
                        className="form-label "
                        htmlFor="collapsible-lastname"
                      >
                        Pocket Code
                      </label>
                      <TextField
                        type="text"
                        fullWidth
                        className="textField"
                        // style={{ width: "310px" }}
                        variant="outlined"
                        value={this.state.pocketcode}
                        onChange={this.handlePocketCodeChange.bind(this)}
                        required
                      />
                    </div>
                  </div>
                  <div className="row p-1">
                    <div className="col-md-12" id="assetFormLabel">
                      <label
                        className="form-label "
                        htmlFor="collapsible-lastname"
                      >
                        Description
                      </label>
                      <textarea
                        type="text"
                        value={this.state.description}
                        onChange={this.handleDescriptionChange.bind(this)}
                        className="form-control"
                        id="exampleFormControlTextarea1"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row d-flex justify-content-center p-4">
                <div className="col-sm-12 text-center align-self-center">
                  <SaveButton btnName="Save" type="submit" />
                  &nbsp;&nbsp;
                  <CancelIconButton
                    btnName="Cancel"
                    onClick={(e) => this.handleAssetCodeClose()}
                  />
                </div>
              </div>
            </DialogContent>
          </ValidatorForm>
        </Dialog>
      </>
    );
  }
}
export default withRouter(AssetCodeMasterList);
